import React from 'react';
import Anchor from "../../objects/Anchor";

const InteractiveWebinarsImage = (props) => {

    const {image, title, uid} = props.webinarsData;
    const clever = props.clever === true ? 'clever' : '';
    let card;

    switch(props.length)
    {
        case 1: card = ''
            break;
        case 2: card = 'col-sm-6'
            break;
        case 3: card = 'col-xl-4'
            break;
        default: card = 'col-sm-6 col-xl-3'
    }

    return (
        <div className={`col-12 ${card} base-card video-card image-only ${clever}`}>
            <Anchor path={`/training/interactive-webinars/${uid}`} anchorClass="card-inner" internal>
                <div className="theme-video-head">
                    <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                </div>
                <div className="theme-video-body">
                    <h3 className="heading-three">{title}</h3>
                    <span className="theme-button">Read more</span>
                </div>
            </Anchor>
        </div>
    );
};

export default InteractiveWebinarsImage;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/InteractiveWebinarsImage.js